<template>
    <b-navbar
      ref="navbar"
      :variant="seethrough ? 'seethrough' : 'white'"
      fixed="top"
      class="d-flex"
      toggleable="lg"
    >
      <b-navbar-brand to="/">
        <img class="banner-img" src="@/assets/Banner.png" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <template v-slot:default="{ expanded }">
          <div :class="expanded ? 'nav-collapse-btn active':'nav-collapse-btn'">
            <div></div>
          </div>
        </template>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav class="font-weight-bold">
        <b-navbar-nav>
          <b-nav-item to="/">
            <b-icon-house class="mr-2" />Home
          </b-nav-item>
          <b-nav-item to="/projects">
            <b-icon-code-slash class="mr-2" />Projects
          </b-nav-item>
          <b-nav-item to="/games">
            <b-icon-controller class="mr-2" />Games
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>

<script>
export default {
  props: ["seethroughpage"],
  data() {
    return {
      seethrough: this.seethroughpage,
    };
  },
  mounted() {
    window.onscroll = () => this.scroll();
  },
  methods: {
    setSeethrough(setting){
      this.seethrough = setting;
    },
    scroll() {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400 ||
        !this.seethroughpage
      ) {
        this.seethrough = false;
      } else {
        this.seethrough = true;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/WuttiFrutti.scss";

nav {
  transition: 0.5s;
}
.bg-seethrough .navbar-nav .nav-link {
  color: $primary;
  transition: 0.15s;
}
.bg-seethrough .navbar-nav .nav-link:hover {
  color: white;
}

.bg-seethrough .navbar-nav .router-link-exact-active,
.bg-white .navbar-nav .router-link-exact-active {
  color: map-get($theme-colors, secondary);
}

.navbar-collapse {
  transition-property: all !important;
  transition-duration: 0.5s !important;
  padding: 0 0.5em;
}

.navbar {
  padding: 0.5em 0 0.5em 0 !important;
}
.navbar-toggler {
  height: 70px;
  width: 70px;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  margin: -0.4em 0;
}

.nav-collapse-btn {
  margin: auto auto;
  position: relative;
  right: 0;
  top: 0;
  width: 42px;
  height: 37px;
  padding: 0.5em 0.5em 0.5em 0.5em;
}

.navbar-toggler:hover {
  background-color: #3636361e;
}

.navbar-light .navbar-toggler {
  border: 0;
  padding: 0;
}

.nav-collapse-btn:after,
.nav-collapse-btn:before,
.nav-collapse-btn div {
  background-color: #363636;
  content: "";
  display: block;
  height: 1px;
  transition: all 0.1s ease-in-out;
}

.nav-collapse-btn div {
  margin: 7px 0;
}

.nav-collapse-btn.active:before {
  transform: translateY(8px) rotate(45deg);
}

.nav-collapse-btn.active:after {
  transform: translateY(-8px) rotate(-45deg);
}

.nav-collapse-btn.active div {
  transform: scale(0);
}

.banner-img {
  max-height: 1.75rem;
  padding: 0 0.5em;
}

@media only screen and (min-width: 992px) {
  .navbar-collapse {
    transition-duration: 0s !important;
  }
}

.navbar {
  padding: 0;
}
</style>